import { Overlay } from 'shared/components/Overlay';
import * as styles from './styles.css';
import { Button, Theme } from '@cian/ui-kit';

interface IPredictionProps {
  onClose: VoidFunction;
  onCloseOverlay: VoidFunction;
  prediction: {
    boldText: string;
    text?: string;
  };
  isLoading: boolean;
}

export const Prediction: React.FC<IPredictionProps> = ({ onClose, onCloseOverlay, prediction, isLoading }) => {
  return (
    <Overlay onClose={onCloseOverlay} open outside>
      <img
        className={styles['ball']}
        src="https://static.cdn-cian.ru/frontend/info-assets/advent/calendar2026/predict-ball.gif"
      />
      <div className={styles['text-container']} data-name="PredictionText">
        <div className={styles['wrapper']}>
          <div aria-label="Закрыть" onClick={onClose} className={styles['close-button']} />
          <div className={styles['card-background']}>
            <div className={styles['card']}>
              <div className={styles['card-image']} />
              <div className={styles['text']}>
                <span className={styles['bold-text']}>{prediction.boldText}</span>
                {prediction.text && <span>{prediction.text}</span>}
              </div>
            </div>
          </div>
          <div className={styles['btn']}>
            <Theme theme="onOverlay">
              <Button
                loading={isLoading}
                fullWidth
                onClick={onClose}
                theme="fill_secondary"
                afterIcon={<div className={styles['btn-icon']} />}
              >
                Отлично!
              </Button>
            </Theme>
          </div>
        </div>
      </div>
    </Overlay>
  );
};
